import React from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import { map } from "lodash";
import "./TableExtraGroupsAdmin.scss";

export function TableExtraGroupsAdmin(props) {
  const { extraGroups, updateExtraGroup, deleteExtraGroup } = props;

  return (
    <Table className="table-extra-groups-admin">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Grupo</Table.HeaderCell>
          <Table.HeaderCell>Orden</Table.HeaderCell>
          <Table.HeaderCell>Items</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {map(extraGroups, (group) => (
          <Table.Row key={group.id}>
            <Table.Cell>{group.label}</Table.Cell>
            <Table.Cell>{group.order}</Table.Cell>
            <Table.Cell>
              {map(
                group.items,
                (item) => `${item.label} (S/ ${item.price})`
              ).join(", ")}
            </Table.Cell>

            <Table.Cell textAlign="right">
              <Button icon onClick={() => updateExtraGroup(group)}>
                <Icon name="pencil" />
              </Button>
              <Button icon negative onClick={() => deleteExtraGroup(group)}>
                <Icon name="close" />
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}
